/**
 * Created by mvasim on 12/9/17.
 */

import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewEncapsulation,
    ChangeDetectorRef,
    ComponentFactoryResolver,
    ViewChild,
} from '@angular/core';

import { Subject } from 'rxjs';
import { FnUtilService } from '../../services/fn-util.service';
import { FnGridService } from './services/fn-grid.service';
import { FnGridRowAction } from './model/fn-grid-row.action';
import { FnGridColumn } from './model/fn-grid-column';
import {
    FnGridConfig,
    FnGridActionParmas,
    FnGridRowHeader,
} from './model/fn-grid.config';
import {
    FN_GRID_ACTION_TYPE_ENUM,
    FN_GRID_COMPONENT_TYPE_ENUM,
} from './model/fn-grid.constant';
import { FnComponentRenderService } from './services/fn-component-render.service';

import {
    filterNumColInRangeArray,
    gridFilterArray,
    sortFnGridRow,
    UniqueKeyGenrator,
} from './util';
import { FnGridRow } from './model/fn-grid-row';
import { FnColumnDef } from './default/fn-grid-colum-def';
import { FnGridCellGroupComponent } from './grid-cell-group/fn-grid-cell-group.component';
import { isNegativeFloat } from '../../util/number';
import { FnTableExportColumn } from './export/fn-grid-export.model';

/**
 * This Component is used to Create Grid-Table .
 * To use this component import FoundationModule in Module.
 */
@Component({
    selector: 'fn-grid',
    templateUrl: 'fn-grid.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [FnGridService], // on component level becuase we want caching on table-component level not globaly
})
export class FnGridComponent implements OnInit, OnDestroy {
    constructor(
        private fnUtil: FnUtilService,
        private cdRef: ChangeDetectorRef,
        private fnGridService: FnGridService,
        private fnCompRenderSvcs: FnComponentRenderService,
        private resolver: ComponentFactoryResolver
    ) {
        this.fnCompRenderSvcs.setFactoryResolver(resolver);
    }

    private static DEFAULT_SORT_CLS = '';
    pageSize = 10;
    @Input() scrollMaxHeight = 442;

    /**
     * member varible
     * used to provide Search Config to FNTableSearchComponent
     */
    tblSearchConfig = {
        actionClear: new Subject(),
    };
    /**
     * private member of type FNTableMetaData
     * used to default sort data by selectedCol
     */
    private selectedCol: FnGridColumn;

    /**
     * public member of string type
     * used to filter table Row Object
     */
    public searchTerm: string;
    /**
     * Unique key exits of fn table component
     */
    private uniquKeyExits: boolean;
    /**
     * member variable
     * used for storing filter Row Data
     */
    public filterArray: Array<FnGridRow | any> = [];
    /**
     * member variable
     * FnGridConfig object used set table properties
     */
    @Input() config: FnGridConfig;
    /**
     * Table Column MetaData
     */
    @Input() rowMetaArray: Array<FnGridColumn> = [];

    @Input() componentMap: any;

    /**
     * table Row MetaData Array used to copy ref of rowMeta Data
     * and also used in ui create table header
     */
    _cellMetaArray: Array<FnGridColumn> = [];
    /**
     * table Row MetaData Array used to use pin column on left side
     * and also used in ui create table header
     */
    leftMetaArray: Array<FnGridColumn> = [];
    /**
     * table Row MetaData Array used to use pin column on right side
     * and also used in ui create table header
     */
    rightMetaArray: Array<FnGridColumn> = [];
    /**
     * Input member variable
     * used to store table row data
     */
    @Input() dataArray: Array<any> = [];
    /**
     * Input member variable
     * used to show current page of table
     */
    @Input() currentPage?: number;

    /**
     * Output member method
     * emit event when table row updated
     */
    @Output() updateRow = new EventEmitter();
    /**
     * Output member method
     * emit event when table row deleted
     */
    @Output() deleteRow = new EventEmitter();
    @Output() updateFilterArray = new EventEmitter();

    /**
     * Output member method
     * emit event when table cell updated
     * @emitObject - {row:rowData,key, column:key}
     */
    @Output() updateCell = new EventEmitter();

    /**
     * Output member method
     * emit event when table cell updated
     * @emitObject - {row:rowData,key, column:key}
     */
    @Output() focusCell = new EventEmitter();

    /**
     * variable to show total no. of page in table pagination
     */
    totalPage: number;
    /**
     * varible to show search box Action row if true
     */
    showSearchBox: boolean;
    /**
     * Array of row that will display on UI
     */
    uiDataArray: Array<FnGridRow> = [];

    /**
     * varible to clone row array to show in single page
     */
    _internalDataArray: Array<FnGridRow | any> = [];

    /**
     * varible to for set header for pdf and csv
     */
    columArray: Array<FnTableExportColumn> = [];
    /**
     * for sorting row data if isRowGrouping enable
     */
    @ViewChild('rowGroupFilter')
    rowGroupFilter: FnGridCellGroupComponent;
    /**
     * row Group Header Array
     */
    groupRowArray: Array<FnGridRowHeader>;
    /**
     * for row Group Data
     */
    groupRowHash: any | Object = {};

    /**
     * Implementing ngOnDestory to unsubscribe table action
     * and triger actionClear complete function
     */
    ngOnDestroy(): void {
        this.config.uiGridAction.unsubscribe();
        this.tblSearchConfig.actionClear.complete();
    }
    private setExportHeader() {
        this.columArray = [];
        for (let i = 0; i < this.rowMetaArray.length; i++) {
            const rowMetaObj = this.rowMetaArray[i];
            if (!rowMetaObj.isHidden) {
                this.columArray.push({
                    dataKey: rowMetaObj.field,
                    header: rowMetaObj.headerName,
                });
            }
        }
    }
    /**
     * method to initalize table page properties
     */
    private initPageConfig() {
        if (this.fnUtil.isEmptyObject(this.config.hidePagination)) {
            this.config.hidePagination = false;
        }
        if (this.fnUtil.isEmptyObject(this.config.isRowGrouping)) {
            this.config.isRowGrouping = false;
        }
        if (!this.config.hidePagination) {
            this.currentPage = 1;
            this.pageSize = this.fnUtil.isEmptyObject(this.config.pageSize)
                ? this.pageSize
                : this.config.pageSize;
            this.calTotalPageSize(this.dataArray);
        } else {
            this.currentPage = 1;
            this.pageSize = this.dataArray.length;
            this.totalPage = 1;
        }
        if (this.fnUtil.isEmptyObject(this.config.uniqueKey)) {
            this.config.uniqueKey = 'primaryKey';
        }
        const _tempMetaHash: any = this.fnUtil.mapFromArray(
            this._cellMetaArray,
            'key'
        );
        this.uniquKeyExits = !this.fnUtil.isEmptyObject(
            _tempMetaHash[this.config.uniqueKey]
        );
    }

    /*
     *  Update action- triggerd manualy from Parent component
     */

    private updateTrigger = (returnRow: any) => {
        for (const key in this.dataArray) {
            if (
                this.uniquKeyExits &&
                this.dataArray[key][this.config.uniqueKey] ===
                returnRow[this.config.uniqueKey]
            ) {
                this.dataArray[key] = returnRow;
                break;
            }
        }
        this.tblSearchConfig.actionClear.next(true);
        this.searchOnRows(this.searchTerm, false);
    };

    /*
     *  Delete action- triggerd manualy from Parent component
     */
    private deleteTrigger = (returnRow: object | any) => {
        for (const index in this.dataArray) {
            if (
                this.uniquKeyExits &&
                this.dataArray[index][this.config.uniqueKey] ===
                returnRow[this.config.uniqueKey]
            ) {
                // tslint:disable-next-line:radix
                this.dataArray.splice(parseInt(index), 1);
                break;
            }
        }
        if (this.uiDataArray.length === 1 && this.currentPage !== 1) {
            this.currentPage -= 1;
        }
        this.tblSearchConfig.actionClear.next(true);
        this.searchOnRows(this.searchTerm, false);
        this.cdRef.detectChanges();
    };

    /*
     *  Action triggerd manualy from Parent component
     */

    tableAction = (tableAction: FnGridActionParmas) => {
        if (tableAction.action === FN_GRID_ACTION_TYPE_ENUM.ADD) {
            this.addRowAction(tableAction.data);
        } else if (tableAction.action === FN_GRID_ACTION_TYPE_ENUM.UPDATE) {
            this.updateTrigger(tableAction.data);
        } else if (tableAction.action === FN_GRID_ACTION_TYPE_ENUM.DELETE) {
            this.deleteTrigger(tableAction.data);
        } else if (tableAction.action === FN_GRID_ACTION_TYPE_ENUM.REFRESH) {
            this.updateDataArray(tableAction.data);
            this.cdRef.markForCheck();
        } else if (tableAction.action === FN_GRID_ACTION_TYPE_ENUM.CLEAR_SEARCH) {
            this.searchTerm = '';
            this.showSearchBox = false;
            this.tblSearchConfig.actionClear.next(true);
            this.searchOnRows(this.searchTerm, false);
        } else {
            // todo
        }
        if (this.searchTerm?.length > 0) {
            this.showSearchBox = false;
            this.toggleSearch();
        }

        // detect change on UI becuase we are using onpush strategy
        this.cdRef.detectChanges();
    };

    /**
     * method to subscribe tableAction method
     */
    ngOnInit() {
        this.config.uiGridAction.subscribe(this.tableAction);
        this.setTableDefaultData();
        this.fnGridService.buildTableActionMap(this.config.gridActionSetupArray);
        this.fnCompRenderSvcs.setComponents(this.componentMap);
        this.setExportHeader();
        if (this.config.isRowGrouping) {
            this.createGroupRows();
        }
    }

    private buildGridRows() {
        this.filterArray = [];
        let uniqueIdGenrator = new UniqueKeyGenrator();

        for (let i = 0; i < this.dataArray.length; i++) {
            const gridRow = new FnGridRow(
                this.dataArray[i],
                i,
                uniqueIdGenrator.getUniqueKey('row', null)
            );
            this.filterArray.push(gridRow);
            this._internalDataArray.push(gridRow);
        }
    }
    /**
     * method to set default table configurations
     */
    private setTableDefaultData() {
        this.currentPage = 1;
        this.copyMetaDataArray();
        //  this.filterArray = this.dataArray;
        this.buildGridRows();

        this.initPageConfig();
        for (let index = 0; index < this._cellMetaArray.length; index++) {
            this._cellMetaArray[index].sortValue = this.fnUtil.isEmptyObject(
                this._cellMetaArray[index].sortValue
            )
                ? FnGridConfig.defaultSortValue
                : this._cellMetaArray[index].sortValue;

            if (this.fnUtil.isEmptyObject(this._cellMetaArray[index].isSortable)) {
                this._cellMetaArray[index].isSortable = FnGridConfig.defaultIsColSort;
            }
            if (this.config.defaultSortKey === this._cellMetaArray[index].field) {
                this.selectedCol = this._cellMetaArray[index];
            }
        }

        if (this.config.defaultSortKey) {
            // this.applySortIcon(this.config.defaultSortKey);
            this.resetDataArray(this.selectedCol);
        } else {
            this.selectedCol = this._cellMetaArray[0];
            this.uiDataArray = this.filterArray.slice(0, this.pageSize);
        }
    }

    public applySortIcon(sortKey: string): void {
        for (const index in this._cellMetaArray) {
            if (this._cellMetaArray[index].field === sortKey) {
                if (this._cellMetaArray[index].sortValue === 0) {
                    this._cellMetaArray[index].sortValue = 1;
                    this._cellMetaArray[index].sortCls = ' fn-global-sort';
                } else {
                    this._cellMetaArray[index].sortValue =
                        this._cellMetaArray[index].sortValue === 1 ? -1 : 1;
                    this._cellMetaArray[index].sortCls =
                        this._cellMetaArray[index].sortValue === 1
                            ? ' fn-global-sort-desc'
                            : ' fn-global-sort-asc';
                }
            } else {
                this._cellMetaArray[index].sortCls = FnGridConfig.defalutSortClass;
                this._cellMetaArray[index].sortValue = FnGridConfig.defaultSortValue;
            }
        }
    }

    public resetDataArray(column: FnGridColumn, skipSortIcon?: boolean) {
        this.selectedCol = column;
        if (!skipSortIcon) {
            this.applySortIcon(column.field);
        }
        column.sortValue = this.fnUtil.isEmptyObject(column.sortValue)
            ? -1
            : column.sortValue;
        const _key = column.sortValue < 0 ? '-' + column.field : column.field;

        const tempArray: Array<FnGridRow> = sortFnGridRow(this.filterArray, _key);
        const startSize = (this.currentPage - 1) * this.pageSize;
        this.uiDataArray = tempArray.slice(startSize, startSize + this.pageSize);
        if (this.config.isRowGrouping) {
            this.createGroupRows();
        }
        this.emitFilteDataForPdf();
    }
    createGroupRows() {
        const rowDataArray = this.filterArray;
        this.groupRowArray = [];
        this.groupRowHash = {};
        for (let i = 0; i < rowDataArray.length; i++) {
            const rowData: any = rowDataArray[i];
            const rowKey = rowData.data[this.config.rowGroupKey];
            if (!this.groupRowHash[rowKey]) {
                this.groupRowHash[rowKey] = [];
                this.groupRowArray.push({ rowName: rowKey, isHidden: true });
            }
            this.groupRowHash[rowKey].push(rowData);
        }
        this.groupRowArray = this.groupRowArray.sort();
    }
    public changeSort(column: FnGridColumn): void {
        if (!column.isSortable) {
            return;
        }
        this.resetDataArray(column);
    }

    public paginzationEvent(eventObj: any) {
        this.currentPage = eventObj;
        this.resetDataArray(this.selectedCol, true);
    }

    public searchOnRows(
        _searchTerm?: string,
        calPagination = true,
        skipFilterKey = true,
        filterKeyStr: string = ''
    ) {
        /* if (calPagination) {
            this.currentPage = 1;
        } */
        if (this.fnUtil.isEmptyObject(_searchTerm)) {
            this.filterArray = this._internalDataArray;
            this.calTotalPageSize(this.filterArray);
        } else {
            this.filterArray = gridFilterArray(
                this._internalDataArray,
                _searchTerm,
                skipFilterKey,
                filterKeyStr
            );
            this.currentPage = 1;
            this.calTotalPageSize(this.filterArray);
        }

        this.resetDataArray(this.selectedCol, true);
    }

    addRowAction(rowObj: object) {
        this.showSearchBox = false;
        this.dataArray.push(rowObj);
        this.tblSearchConfig.actionClear.next(true);
        this.searchOnRows(this.searchTerm, false);
    }

    public filterAction(rowArray: Array<object>) {
        this.dataArray = rowArray;
        this.searchTerm = '';
        this.searchOnRows();
    }

    updateDataArray = (dataArray: Array<any>) => {
        this.dataArray = [];
        this.dataArray = dataArray;
        this.setTableDefaultData();
    };

    public cellClick(rowObj: object, columnName: string) {
        this.updateAction(rowObj);
    }
    updateAction = (rowObj: object) => {
        this.showSearchBox = false;
        this.updateRow.emit(rowObj);
        this.tblSearchConfig.actionClear.next(true);
        this.searchOnRows(this.searchTerm, false);
    };

    deleteAction = (rowObj: object) => {
        this.showSearchBox = false;
        this.deleteRow.emit(rowObj);
        this.tblSearchConfig.actionClear.next(true);
        this.searchOnRows(this.searchTerm, false);
    };

    public toggleSearch() {
        this.searchTerm = '';
        if (this.showSearchBox) {
            this.searchTerm = '';
            this.tblSearchConfig.actionClear.next(false);
        }
        this.searchOnRows();
        this.showSearchBox = !this.showSearchBox;
    }

    updateCellAction(val: any, rowObject: object | any, column: FnGridColumn) {
        // TODO callback
        rowObject[column.field] = val;
        this.updateCell.emit({ value: val, row: rowObject, key: column.field });
    }

    closeSearch(event: any) {
        this.toggleSearch();
    }
    private calTotalPageSize(arr: Array<any>) {
        this.totalPage = Math.ceil(arr.length / this.pageSize);
    }
    private copyMetaDataArray() {
        let uniqueIdGenrator = new UniqueKeyGenrator();
        this._cellMetaArray = [];
        for (let i = 0; i < this.rowMetaArray.length; i++) {
            this._cellMetaArray.push(
                new FnColumnDef(
                    { ...this.rowMetaArray[i] },
                    uniqueIdGenrator.getUniqueKey('column', null)
                )
            );
            //this._cellMetaArray.push({ ...this.rowMetaArray[i] });
        }
    }

    cellStyleFormatting(objectValue: any, column: FnGridColumn) {
        if (column.cellStyleFormatting) {
            return column.cellStyleFormatting(objectValue, column.field);
        } else {
            return '';
        }
    }

    valueFormatter(gridRow: FnGridRow | any, column: FnGridColumn) {
        if (column.valueFormatter) {
            return column.valueFormatter(gridRow.data, column.field);
        } else {
            return gridRow.data[column.field];
        }
    }

    onRowAction(rowAction: FnGridRowAction) {
        const _tableAction = this.fnGridService.getActionMapForId(
            rowAction.actionSetupID
        );
        // TODO _tableAction
    }

    private recallCellValue(
        cellValue: any,
        fnGridRow: FnGridRow | any,
        column: FnGridColumn,
        lookupKeyVal?: string
    ) {
        // fnGridRow.data[column.field] = cellValue;
        //   let formattedVal = this.valueFormatter(fnGridRow,column);
        const uniqueKey = this.config.uniqueKey;
        for (let i = 0; i < this._internalDataArray.length; i++) {
            if (this._internalDataArray[i][uniqueKey] == fnGridRow[uniqueKey]) {
                console.log('MATCHED');
                this._internalDataArray[i].data[column.field] = cellValue;
                if (lookupKeyVal) {
                    this._internalDataArray[i].data[column.lookupIdKeyInRow] =
                        lookupKeyVal;
                }
                break;
            }
        }

        for (let i = 0; i < this.filterArray.length; i++) {
            if (this.filterArray[i][uniqueKey] == fnGridRow[uniqueKey]) {
                console.log('MATCHED INSIDE FILTER');
                this.filterArray[i].data[column.field] = cellValue;
                if (lookupKeyVal) {
                    this._internalDataArray[i].data[column.lookupIdKeyInRow] =
                        lookupKeyVal;
                }
                break;
            }
        }
    }

    changCellAction(val: any, rowObject: FnGridRow | any, column: FnGridColumn) {
        rowObject[column.field] = val;
        if (column.enableChageAcion) {
            this.fnGridService
                .gridApiPostAction(val, rowObject, column, this.config.uniqueKey)
                .subscribe((resp) => {
                    this.recallCellValue(resp[column.field], rowObject, column);
                });
            this.updateCell.emit({ value: val, row: rowObject, key: column.field });
        } else {
            this.recallCellValue(val, rowObject, column);
            this.updateCell.emit({ value: val, row: rowObject, key: column.field });
        }
    }
    selectionChange(
        eventData: any,
        rowObject: FnGridRow | any,
        column: FnGridColumn
    ) {
        const val = eventData.cellValue; //eventData.lookupKeyVal

        rowObject[column.field] = val;
        if (column.enableChageAcion) {
            this.fnGridService
                .gridApiPostAction(val, rowObject, column, this.config.uniqueKey)
                .subscribe((resp) => {
                    this.recallCellValue(
                        resp[column.field],
                        rowObject,
                        column,
                        eventData.lookupKeyVal
                    );
                });
            this.updateCell.emit({ value: val, row: rowObject, key: column.field });
        } else {
            this.recallCellValue(val, rowObject, column, eventData.lookupKeyVal);
            this.updateCell.emit({ value: val, row: rowObject, key: column.field });
        }
    }

    cellClickAction(val: any, rowObject: FnGridRow, column: FnGridColumn) {
        //rowObject[column.field] = val;
        //this.updateCell.emit({ value: val, row: rowObject, key: column.field });

        if (column.enableClickAcion) {
            this.focusCell.emit({ value: val, row: rowObject, key: column.field });
        }
    }
    cellFocusAction(val: any, rowObject: FnGridRow, column: FnGridColumn) {
        // rowObject[column.field] = val;
        if (column.enableFocusAcion) {
            this.focusCell.emit({ value: val, row: rowObject, key: column.field });
        }
    }

    cellBlurAction(val: any, rowObject: FnGridRow | any, column: FnGridColumn) {
        rowObject[column.field] = val;
        if (column.enableBlurAcion) {
            this.fnGridService
                .gridApiPostAction(val, rowObject, column, this.config.uniqueKey)
                .subscribe((resp) => {
                    this.recallCellValue(resp[column.field], rowObject, column);
                });
            this.updateCell.emit({ value: val, row: rowObject, key: column.field });
        } else {
            this.recallCellValue(val, rowObject, column);
        }
    }

    actionOnHeader(event: any, column: FnGridColumn) {
        const field = column.field;
        switch (event.type) {
            case 'TEXT':
                this.searchOnRows(event.searchTerm, true, false, field);
                break;
            case 'NUM':
                this.inRangeSearchOnCol(event, field);
                break;
            case 'BOOLEAN':
                if (event.noDataSelected) {
                    this.noRowSelected();
                } else {
                    this.searchOnRows(event.searchTerm, true, false, field);
                }
                break;
            case 'resetAll':
                this.resetAllpinToCol();
                break;
            case 'pinTo':
                this.pinColumn(event.pinTo, column);
                break;
            default:
                this.searchOnRows(event.searchTerm, true, false, field);
                break;
        }
    }
    private pinColumn(pinTo: string, column: FnGridColumn) {
        const currentPinTo = column.pinTo;
        if (currentPinTo !== pinTo) {
            column.pinTo = pinTo;
            column.isPinTo = true;
            if (pinTo === 'left') {
                if (currentPinTo === 'right') {
                    this.unPinColumn(currentPinTo, column);
                }
                this.leftMetaArray.push(column);
            } else if (pinTo === 'right') {
                if (currentPinTo === 'left') {
                    this.unPinColumn(currentPinTo, column);
                }
                this.rightMetaArray.push(column);
            } else {
                column.isPinTo = false;
                this.unPinColumn(currentPinTo, column);
            }
        }
    }
    private unPinColumn(pinTo: string, column: FnGridColumn) {
        const colMetaArray =
            pinTo === 'right' ? this.rightMetaArray : this.leftMetaArray;
        this.removeColFromArray(column.field, colMetaArray);
    }
    private removeColFromArray(field: string, colMetaArray: Array<FnGridColumn>) {
        for (let i = 0; i < colMetaArray.length; i++) {
            if (field === colMetaArray[i].field) {
                colMetaArray.splice(i, 1);
                break;
            }
        }
    }

    private resetAllpinToCol() {
        if (this.leftMetaArray.length > 0 || this.rightMetaArray.length > 0) {
            this.copyMetaDataArray();
            this.leftMetaArray = [];
            this.rightMetaArray = [];
        }
    }

    private noRowSelected() {
        this.filterArray = [];
        this.currentPage = 1;
        this.calTotalPageSize(this.filterArray);
        this.resetDataArray(this.selectedCol, true);
    }
    private inRangeSearchOnCol(event: any, field: string) {
        const numFrom = event.numFrom;
        const numTo = event.numTo;
        if (isNegativeFloat(numFrom) && isNegativeFloat(numTo)) {
            this.filterArray = filterNumColInRangeArray(
                this._internalDataArray,
                Number(numFrom),
                Number(numTo),
                field
            );
            this.currentPage = 1;
            this.calTotalPageSize(this.filterArray);
            this.resetDataArray(this.selectedCol, true);
            return;
        }
        this.searchOnRows('');
    }
    private emitFilteDataForPdf() {
        const filterArray: Array<any> = [];
        for (let i = 0; i < this.filterArray.length; i++) {
            filterArray.push(this.filterArray[i].data);
        }
        this.updateFilterArray.emit(filterArray);
    }
}
